import { render, staticRenderFns } from "./ExtraFieldsEditText.vue?vue&type=template&id=b5e15340"
import script from "./ExtraFieldsEditText.vue?vue&type=script&lang=ts"
export * from "./ExtraFieldsEditText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5e15340')) {
      api.createRecord('b5e15340', component.options)
    } else {
      api.reload('b5e15340', component.options)
    }
    module.hot.accept("./ExtraFieldsEditText.vue?vue&type=template&id=b5e15340", function () {
      api.rerender('b5e15340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExtraFieldsEditText.vue"
export default component.exports